import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { queryKeys } from '@utils/consts';
import { TaskTypesRespSuccess } from './types';
import { useAppContext } from '@contexts/app';
import { useQueryParams } from '@hooks/queryParams';

export const useTaskTypesDropdown = () => {
  const { isDropdownEnabled: enabled } = useAppContext();

  const {
    params: { workflowIds, stages: stageNames },
    parseParams,
  } = useQueryParams();

  const queryParams = parseParams({ workflowIds, stageNames }, { arrayFormat: 'bracket' });

  const { data, error, isPending } = useQuery<TaskTypesRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.taskTypes, queryParams],
    queryFn: () => queryFetch({ url: `dropdowns/task_types${queryParams}` }),
    enabled,
    placeholderData: (previousData) => previousData as TaskTypesRespSuccess,
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && enabled,
  };
};
